import React from "react";
import {
  View,
  Dimensions,
  PixelRatio,
  Modal,
  TouchableWithoutFeedback,
} from "react-native";
import SuccessIcon from "@assets/svg/SuccessIcon";
import Cross from "@components/RaiseTicket/Cross";
import Text from "@components/AppText";
import Button from "@components/Button";
import Oops from "@assets/svg/Oops";

const { width, height } = Dimensions.get("window");
const scale = width / 360;

function normalize(size) {
  const newSize = size * scale;
  return Math.round(PixelRatio.roundToNearestPixel(newSize));
}

const Success = ({ message, onPress, visible }) => {
  return (
    <Modal
      animationType="slide"
      transparent={false}
      onRequestClose={onPress}
      //   onDismiss={}
      visible={visible}
      presentationStyle="fullScreen"
    >
      <View style={{ flex: 1 }}>
        <TouchableWithoutFeedback onPress={onPress}>
          <View
            style={{
              marginLeft: normalize(15),
              marginTop: normalize(40),
              width: normalize(27),
              height: normalize(27),
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Cross />
          </View>
        </TouchableWithoutFeedback>

        <View
          style={{
            alignItems: "center",
            justifyContent: "center",
            alignSelf: "center",
            flex: 1,
            width: width * 0.78,
          }}
        >
          <SuccessIcon />
          <Text
            bold
            style={{
              fontSize: normalize(24),
              lineHeight: normalize(34),
              marginVertical: normalize(5),
            }}
          >
            Successful!
          </Text>
          <Text
            style={{
              textAlign: "center",
              fontSize: normalize(16),
              lineHeight: normalize(24),
            }}
          >
            {message}
          </Text>
        </View>
        <Button
          btnText="Okay"
          buttonFontType="bold"
          onPress={onPress}
          fontSize={normalize(18)}
          buttonWidth={width * 0.88}
          height={normalize(50)}
          borderRadius={10}
          containerStyle={{ alignSelf: "center", marginBottom: normalize(20) }}
        />
      </View>
    </Modal>
  );
};

export default Success;
